import React from 'react';
import TableHoverCard from './TableHoverCard';
import UserAvatar from './UserAvatar';
import UserProfileCard from './UserProfileCard';

const InlineUserCell = ({
    row,
    index,
    userField,
    type,
    canEdit,
    handleUserMouseEnter,
    handleUserMouseLeave,
    handleUserClick,
    hoveredUser,
    showModal,
    setShowModal,
    handleCardMouseEnter,
    handleCardMouseLeave,
    setHoveredUser,
    dropdownState,
    dropdownComponent: DropdownComponent,
    dropdownProps = {}
}) => {
    // 2. Calculate assign/select dropdown position
    const windowHeight = document.documentElement.clientHeight;
    const dropdownHeight = 160;
    const dropdownAvailableSpaceAbove = index * dropdownHeight;
    const dropdownAvailableSpaceBelow = windowHeight - (dropdownAvailableSpaceAbove + dropdownHeight);

    let dropdownStyle = {};
    if (dropdownAvailableSpaceBelow > dropdownAvailableSpaceAbove) {
        dropdownStyle = { top: "22px" };
    } else {
        dropdownStyle = { bottom: "30px" };
    }

    return (
        <div
            onMouseEnter={handleUserMouseEnter ? e => handleUserMouseEnter(e, row, type) : undefined}
            onMouseLeave={handleUserMouseLeave}
            style={{ display: "inline-block", overflow: "visible", textTransform: "capitalize" }}
        >
            <div 
                onClick={canEdit && handleUserClick ? e => handleUserClick(e, row) : undefined} 
                className='d-flex align-items-center' 
                style={{ cursor: canEdit && handleUserClick ? "pointer" : "default" }}
            >
                <UserAvatar username={userField?.username} image={userField?.image} marginRight="7px" />
                <span className="hyperlink">{userField?.username}</span>
            </div>

            {/* Hover User Profile Card */}
            <TableHoverCard
                show={hoveredUser?.show && hoveredUser?.rowId === row.id && hoveredUser?.type === type}
                index={index}
                placement="left"
                cardWidth={380}
                popupHeight={180}
                offsetX={5}
                anchorRect={hoveredUser?.anchorPos}
                portalToBody
                viewportPadding={16}
                zIndex={10000}
                onMouseEnter={handleCardMouseEnter}
                onMouseLeave={handleCardMouseLeave}
            >
                {hoveredUser?.show && hoveredUser?.rowId === row.id && hoveredUser?.type === type && (
                    <UserProfileCard 
                        row={userField} 
                        index={index} 
                        showModal={showModal} 
                        setShowModal={setShowModal}
                        handleCardMouseEnter={handleCardMouseEnter} 
                        handleCardMouseLeave={handleCardMouseLeave}
                        closeHoverCard={() => setHoveredUser({ show: false, rowId: null, type: null, anchorPos: { x: 0, y: 0 }, locked: false })}
                    />
                )}
            </TableHoverCard>

            {/* Editing Dropdown Option List */}
            {dropdownState?.open && dropdownState?.rowId === row.id && DropdownComponent && (
                <div
                    style={{
                        position: "absolute",
                        left: "0px",
                        zIndex: 4,
                        background: "transparent",
                        ...dropdownStyle
                    }}
                    onMouseEnter={() => setHoveredUser({ show: false, rowId: null, type: null, anchorPos: { x: 0, y: 0 }, locked: false })}
                >
                    <DropdownComponent {...dropdownProps} />
                </div>
            )}
        </div>
    );
};

export default InlineUserCell;
